module.exports = __webpack_public_path__ + "static/media/inativar.0510523d.svg";